import { withLayoutProps } from '@/utils/withLayoutProps';

import { StyledParagraph } from './styles';

import type { ParagraphSizeVariant } from './styles';
import type { ThemeColor } from '@/styles/theme';
import type { HTMLAttributes, ReactNode } from 'react';

interface ParagraphProps extends HTMLAttributes<HTMLParagraphElement> {
  children: ReactNode;
  size?: ParagraphSizeVariant;
  color?: ThemeColor;
  weight?: 400 | 500 | 600 | 700;
  textAlign?: 'left' | 'center' | 'right';
  // Enable flexbox alignment for (vertically) centering text with icons or other elements
  flexAlignCenter?: boolean;
  noWrap?: boolean;
}

const Paragraph = withLayoutProps(
  ({
    size = 'md',
    color = 'bodyTextColor',
    weight = 500,
    textAlign = 'left',
    flexAlignCenter = false,
    children,
    noWrap,
    ...props
  }: ParagraphProps) => (
    <StyledParagraph
      $sizeVariant={size}
      $colorVariant={color}
      $weight={weight}
      $textAlign={textAlign}
      $flexAlignCenter={flexAlignCenter}
      $noWrap={noWrap}
      {...props}
    >
      {children}
    </StyledParagraph>
  ),
);

export { Paragraph };
